export default __webpack_public_path__ + "static/media/employeetracker.b3e91761.png";